<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>DEAN STUDENT’S WELFARE</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Dean Students’ Welfare</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<!-- ABOUTUS
       ================================================== -->
<section class="aboutus-style-02 py-6">
    <div class="container">
        <div class="row align-items-center ">
            <div class="col-lg-12 col-xl-12 mt-lg-4">
                <div class="section-heading mb-0 text-center">
                    <span class="sub-title">DWS</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary text-center">ABOUT US</h2>
                <p class="px-2" align="justify">The Office of the Dean Students' Welfare acts as a central facilitation center to help students in
                    every possible manner to ensure the best utilization of their potential. We aim to promote
                    cooperation and fellowship among students by coordinating various activities for the welfare of the
                    students. The students are encouraged to express their hidden talents and latent abilities to
                    realize their full potential and add vibrancy to campus life.
                </p>

                <p class="px-2" align="justify">Student life is full of challenges and these challenges unfold opportunities to grow professionally,
                    socially, and mentally. Apart from targeting academic excellence, you must simultaneously
                    participate in co-curricular and extra-curricular activities. This would help to bring out the best
                    in you. I hope you enjoy your journey with the University and utilize the best of your potential
                    here.</p>

                <p class="px-2" align="justify">Best of luck for your future endeavours!</p>
                <p class="px-2" align="justify">Dr. Sunita</p>
                <p class="px-2" align="justify">Dean Students’ Welfare</p>
            </div>
        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>


<section class="aboutus-style-02 pb-6 pt-0">
    <div class="container">
        <div class="accordion" id="accordionExample">

            <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                    <button class="accordion-button bg-secondary text-white" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true" aria-controls="collapseOne">
                        SCHEMES
                    </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                     data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <section class="aboutus-style-02 mt-0 mb-0 py-6">
                            <div class="container ">
                                <div class="row align-items-center">
                                    <div class="col-lg-12 col-xl-12 p-0">
                                        <div class="section-heading text-start mb-0">
                                            <span class="sub-title">SCHEMES</span>
                                        </div>
                                        <h2 class="h1 mb-1-6 text-primary">Financial Assistance to the Needy
                                            Students</h2>
                                        <p class="" align="justify">Dean Students Welfare office provides financial assistance to the needy
                                            students of various University Teaching Departments. University strives to
                                            promote academic excellence of the students who are economically weak, needy
                                            or poor and not able to pay their fee for higher studies to the students
                                            studying in university teaching departments.</p>

                                        <h2 class="h1 mb-1-6 text-primary">Earn While You Learn Scheme</h2>
                                        <p align="justify">The spirit of the scheme is based on the idea of enabling needy students to
                                            meet a part of their educational expenses with dignity. The scheme provides
                                            support to the students for working in University Teaching Departments or
                                            performing office related work for some fixed hours in a week with
                                            remuneration per month.</p>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>

            <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                    <button class="accordion-button collapsed bg-secondary text-white" type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        ORIENTATION PROGRAMS
                    </button>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                     data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <section class="aboutus-style-02 mt-0 mb-0 py-6">
                            <div class="container">
                                <div class="row align-items-center">
                                    <div class="col-lg-12 col-xl-12 p-0">
                                        <div class="section-heading text-start mb-0">
                                            <span class="sub-title">ORIENTATION PROGRAMS</span>
                                        </div>
                                        <p align="justify">The orientation program is meant to celebrate your arrival and orient you to
                                            campus life. You are about to embark on a new adventure in your education,
                                            career, and personal life. We believe you are all "Superheroes", with your
                                            unique abilities and exceptional energy to solve the world's problems. You
                                            are provided opportunities to learn about campus resources to help you
                                            defeat the hurdles of campus life.</p>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>

            <div class="accordion-item">
                <h2 class="accordion-header" id="headingThree">
                    <button class="accordion-button collapsed bg-secondary text-white" type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        FEEDBACK
                    </button>
                </h2>
                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                     data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <section class="aboutus-style-02 mt-0 mb-0 py-6">
                            <div class="container">
                                <div class="row align-items-center">
                                    <div class="col-lg-12 col-xl-12 p-0">
                                        <div class="section-heading text-start mb-0">
                                            <span class="sub-title">FEEDBACK</span>
                                        </div>
                                        <h2 class="h1 mb-1-6 text-primary">ONLINE STUDENT'S FEEDBACK</h2>
                                        <p align="justify">Feedback is a vital part of communication that if acknowledged in affirmative
                                            way can improve the working of the organization. Feedback mechanism helps to
                                            identify the critical areas of concern. Arni University highly appreciates
                                            and work-on the suggestions and feedback given by students.</p>
                                        <div class="section-heading text-start mb-0">
                                            <p>GO TO LINK : <span class="sub-title text-secondary">
                                                <a class="text-secondary" target="_blank"
                                                   href="Student Feedback https://forms.gle/eUqeHfyZiTMhda3S9">
                                                    Student Feedback https://forms.gle/eUqeHfyZiTMhda3S9</a>
                                            </span>
                                            </p>
                                        </div>
                                        <div class="section-heading text-start mb-0">
                                            <p>CONTACT US : <span class="sub-title ">
                                                <a class="text-secondary" target="_blank"
                                                   href="dsw@arniuniversity.edu.in">
                                                    dsw@arniuniversity.edu.in</a>
                                            </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>

            <div class="accordion-item">
                <h2 class="accordion-header" id="headingFour">
                    <button class="accordion-button collapsed bg-secondary text-white" type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                        COMMITTEE
                    </button>
                </h2>
                <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="collapseFour"
                     data-bs-parent="#accordionExample">
                    <div class="accordion-body">

                       <section class="contact-form pb-0 py-6  ">

                            <div class="container">
                                <div class="section-heading text-start mb-0">
                                    <span class="sub-title">COMMITTEE</span>
                                </div>
                                <div class="row mt-n2-9 mb-md-6 mb-lg-7">

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Dr. Sunita</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">DSW</a></li>
                                                    <li><a href="#!">Chairperson</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Ms. Neha Rani</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Asst. Professor CSE</a></li>
                                                    <li><a href="#!">Member Secretary</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Ms. Mehr Un Nisa</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Assistant Registrar (Students Care & Support
                                                        Cell)</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Dr. Shreya Singh</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">HOD- Agriculture</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Mr. Irshad Ahmad Sofi</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">HOD- Mgt & Commerce</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Mr. Mannu Mahajan</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Asst. Professor- Commerce</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Mr. Swadhin Kumar Rout</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Asst. Professor Business Mgt</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Dr. Pooja Ghosh</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Asst. Professor Physiotherapy</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Ms. Manju Bala</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Academic Associate Maths</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Ms. Geetanjali</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Asst. Professor Radiology</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Mr. Akash Kumar Sharma (Pharmacy)</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Students</a></li>
                                                    <li><a href="#!">Representative member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Ms. Tannvi Malpotra (Pharmacy)</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Students</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Ms. Shabnam</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Students</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Ms. Payal Samyal (Radiology)</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Students</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Mr. Mohd. Ashfaq (Radiology)</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Students</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Mr. Aksheesh Jaggi (Civil)</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Students</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Mr. Aniket Katoch (Pharmacy)</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Students</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Mr. Arjun (Pharmacy)</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Students</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Ms. Suzain Khan (Pharmacy)</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Students</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Ms. Nargis</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Students</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Mr. Rishabh</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Students</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Ms. Kailasha</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Students</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Mr. Karan</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Students</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 mt-2-9">
                                        <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                                            <div>
                                                <h4>Mr. Abhishek Vashisth</h4>
                                                <ul class="list-unstyled p-0 m-0">
                                                    <li><a href="#!">Students</a></li>
                                                    <li><a href="#!">Member</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>

            <div class="accordion-item">
                <h2 class="accordion-header" id="headingFive">
                    <button class="accordion-button collapsed bg-secondary text-white" type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                        STUDENT CLUBS
                    </button>
                </h2>
                <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="collapseFive"
                     data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <section class="aboutus-style-02 mt-0 mb-0 py-6">
                            <div class="container">
                                <div class="row align-items-center">
                                    <div class="col-lg-12 col-xl-12 p-0">
                                        <div class="section-heading text-start mb-0">
                                            <span class="sub-title">STUDENT CLUBS</span>
                                        </div>
                                        <p>1. Environment Club - "Green Club" (Arni School of Basic Sciences &
                                            Bio-Technclogy)</p>
                                        <p>2. Music Club - "Rhythm Club" (Ami School of Arts & Humanities)</p>
                                        <p>3. Dance Club - "Dance Fusion" (Ami School of Agriculture and Arts &
                                            Humanities)</p>
                                        <p>4. Sports Club - "Champions Club" (Ami School of Education & Sports)</p>
                                        <p>5. Red Cross Club - (Arni School of Pharmacy & Allied Health Sciences)</p>
                                        <p>6. Tech Club - "Social Spark" (Ami School of Technology)</p>
                                        <p>7. Literature Club - "Reader's Lounge" (Arni School of Arts & Humanities)</p>
                                        <p>8. Debate Club - "Brainstorm" (Arni School of Business Management &
                                            Commerce)</p>
                                        <p>9. Drama Club - "Stage Strivers" (Arni School of Arts & Humanities)</p>
                                        <p>10. Human Ethics Club - (Arni School of Law)</p>
                                        <p>11. National Cadets Corps NCC</p>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
